
<div>
  <provider-profile-error v-if="generalErrorType" :errorType="generalErrorType" />
  <div v-else>
    <provider-profile-banner v-if="bannerType" :bannerType="bannerType" />
    <provider-profile-container
      :profileAccountData="profileAccountData"
      :viewerAccountData="account"
      :loading="loading"
      :bannerType="bannerType"
      :paramData="paramData"
      :accountTypeInfo="accountTypeInfo"
    />
  </div>
</div>
